<template>
  <div class="dashboard__notif-todo">
    <p class="dashboard__notif-todo--title">{{dataList.title}}</p>
    <p class="fontstyle__defaultdashboard--blue">{{dataList.subtitle}}</p>
    <div v-if="isLoading" class="spinner__medium--blue
        dashboard__notif-todo--emptydata">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else-if="dataList.data && dataList.data.length > 0">
      <div class="row m-0 py-2 dashboard__notif-todo--content" @click="goToDetail(data)" v-for="(data, i) in dataList.data" :key="i">
        <div class="col1 d-flex justify-content-center flex-column p-0">
          <img class="mb-2 message-image" :src="data.messageImage" alt="">
          <p class="dashboard__notif-todo--font10">{{getDate(data.date)}}</p>
        </div>
        <div class="col2 p-0">
          <p class="fontstyle__defaultdashboard--blue reference_number">{{data.referenceNumber}}</p>
          <p class="fontstyle__default--blue">{{data.originCity || data.origin}} - {{data.destinationCity || data.destination}}</p>
          <div style="line-height: 1" class="pt-1">
            <b class="dashboard__notif-todo--font10">{{data.messageType}}</b>
            <div class="row m-0">
              <img src="@/assets/image/icon/dashboard-blue-arrow.svg" alt="">
              <p class="pl-1 pt-1 dashboard__notif-todo--font10">{{data.message}}</p>
            </div>
          </div>
        </div>
        <div class="col3">
           <img class="alert-image" :src="data.alertImage" alt="">
        </div>
      </div>
       <div class="dashboard__notif-todo--footer text-center pt-2">
         <router-link tag="p" :to="dataList.link" >
          See More
        </router-link>
      </div>
    </div>
    <div v-else>
      <div class="dashboard__notif-todo--emptydata">
        <img :src="dataList.emptyData.image" alt="">
        <b class="mt-2">{{dataList.emptyData.text}}</b>
      </div>
      <div class="dashboard__notif-todo--footer text-center pt-2">
        <router-link tag="p" :to="dataList.link" >
          See History
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import dashboardMixin from '@/mixin/dashboard/invoice_notif_todolist'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'DashboardNotifAndTodoList',
  props: {
    dataList: Object,
    isLoading: Boolean
  },
  components: {
    HalfCircleSpinner
  },
  mixins: [dashboardMixin],
  methods: {
    getDate (item) {
      return moment(item).format('MMM, DD')
    },
    goToDetail (data) {
      if (this.dataList.title === 'TO DO LIST') {
        const paylaod = {
          id: data.id,
          referenceNumber: data.referenceNumber,
          topic: data.topic
        }
        this.$store.dispatch('dashboard/UPDATE_ISREAD_TODO', paylaod)
        this.$router.push(this.getRouterNameDashboard(data))
      } else {
        const paylaod = {
          referenceId: data.id,
          referenceNumber: data.referenceNumber,
          topic: data.topic
        }
        this.$store.dispatch('dashboard/UPDATE_ISREAD_NOTIF', paylaod)
        this.$router.push(this.getRouterNameDashboard(data))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/NotifAndTodolist.vue